import React, { useState } from 'react';
import { TableCell, TableSortLabel, Menu, MenuItem, ButtonBase, StepButton, ButtonGroup, IconButton } from '@material-ui/core';




export const SortableTableCell = ({id, currentOrderById, handleSortRequest, children, className}) => {
    const [order, setOrder] = React.useState('asc')

    const flippedOrder = () => order == 'desc' ? 'asc' : 'desc'
    const flip = () => setOrder(flippedOrder())

    const handleClick = (id) => event => {
        handleSortRequest(id, flippedOrder())
        flip()
    }

    return (
            <TableCell
             className={`${className} clickable`}
              key={id}
              sortDirection={currentOrderById === id ? order : false}>
                <TableSortLabel
                    active={currentOrderById === id}
                    direction={order}
                    onClick={handleClick(id)}>
                    {children}
                </TableSortLabel>
            </TableCell>)
}


export const SortableAndFilterableTableCell = ({id, currentOrderById, handleSortRequest, filterOptions, firstFilter, filters,  handleFilterChange, children, className
  }) => {
    const [order, setOrder] = useState('asc');
    const [anchorEl, setAnchorEl] = useState(null);  
    const flippedOrder = () => (order === 'desc' ? 'asc' : 'desc');
    const flipOrder = () => setOrder(flippedOrder());
  
    const handleSortClick = (event) => {
      handleSortRequest(id, flippedOrder());
      flipOrder();
    };
  
    const handleFilterClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleFilterClose = () => {
      setAnchorEl(null);
    };
  
    const handleFilterOptionClick = (value) => {
      handleFilterChange(id, value === 'All' ? '' : value);
      setAnchorEl(null);
    };
  
    return (
      <TableCell className={`${className} clickable`} key={id} sortDirection={currentOrderById === id ? order : false}>
        <TableSortLabel active={currentOrderById === id} direction={order} onClick={handleSortClick}>
          {children}
        </TableSortLabel>
        <div style={{ display: 'inline-block', marginLeft: '5px' }}>
        <ButtonBase onClick={handleFilterClick} >{filters[id] ? filters[id] : "All" }</ButtonBase>
          <Menu anchorEl={anchorEl} open={anchorEl!==null} onClose={handleFilterClose}>
            {filterOptions.map((option) => (
              <MenuItem key={option} onClick={() => handleFilterOptionClick(option)}>
                {option}
              </MenuItem>
            ))}
          </Menu>
        </div>
      </TableCell>
    );
  };